import { AnyAction, combineReducers } from "@reduxjs/toolkit";
import CollapseSlice from "./jetlift/collapse/collapseSlice";
import TubingSlice from "./jetlift/jetlift-input/TubingSlice";
import WellSlice from "./jetlift/jetlift-input/WellSlice";
import FluidSlice from "./jetlift/jetlift-input/FluidSlice";
import JetPumpSlice from "./jetlift/jetlift-input/JetPumpSlice";
import OthersSlice from "./jetlift/jetlift-input/OthersSlice";
import ProjectHeaderSlice from "./jetlift/project-header/ProjectHeaderSlice";
import GasCalculationSlice from "./jetlift/jetlift-output/GasCalculationSlice";
import BasicCalculationSlice from "./jetlift/jetlift-output/BasicCalculationSlice";
import SurfaceEquipmentSlice from "./jetlift/jetlift-output/SurfaceEquipmentSlice";
import SchematicSlice from "./jetlift/jetlift-output/SchematicSlice";
import WellSurveySlice from "./jetlift/jetlift-output/WellSurveySlice";
import JetliftCalculationSlice from "./jetlift/JetliftCalculationSlice";
import JetliftComparisonSlice from "./jetlift/comparison/ComparisonSlice";

import { initialState as tubingState } from "./jetlift/jetlift-input/TubingSlice";
import { initialState as wellState } from "./jetlift/jetlift-input/WellSlice";
import { initialState as fluidState } from "./jetlift/jetlift-input/FluidSlice";
import { initialState as jetPumpState } from "./jetlift/jetlift-input/JetPumpSlice";
import { initialState as calculationState } from "./jetlift/JetliftCalculationSlice";
import { initialState as otherState } from "./jetlift/jetlift-input/OthersSlice";
import { initialState as collapseState } from "./jetlift/collapse/collapseSlice";
import { initialState as projectHeaderState } from "./jetlift/project-header/ProjectHeaderSlice";
import { initialState as GasCalculationState } from "./jetlift/jetlift-output/GasCalculationSlice";
import { initialState as basicCalculationState } from "./jetlift/jetlift-output/BasicCalculationSlice";
import { initialState as surfaceEquipmentState } from "./jetlift/jetlift-output/SurfaceEquipmentSlice";
import { initialState as schematicState } from "./jetlift/jetlift-output/SchematicSlice";
import { initialState as wellSurveyState } from "./jetlift/jetlift-output/WellSurveySlice";
import { initialState as JetliftComparisonState } from "./jetlift/comparison/ComparisonSlice";


export const jetliftReducer = combineReducers({
    collapse: CollapseSlice,
    tubing: TubingSlice,
    well: WellSlice,
    fluid: FluidSlice,
    calculations: JetliftCalculationSlice,
    comparison: JetliftComparisonSlice,
    jetPump: JetPumpSlice,
    others: OthersSlice,
    projectHeader: ProjectHeaderSlice,
    gasCalculations: GasCalculationSlice,
    basicCalculations: BasicCalculationSlice,
    surfaceEquipment: SurfaceEquipmentSlice,
    schematic: SchematicSlice,
    wellSurvey: WellSurveySlice,
});

export const rootJetliftReducer = (state: ReturnType<typeof jetliftReducer> | undefined, action: AnyAction) => {
    if (action.type === 'RESET_STORE') {
        return jetliftReducer({
            ...state,
            projectHeader: projectHeaderState, 
            tubing: tubingState,
            well: wellState,
            fluid: fluidState,
            calculations: calculationState,
            comparison: JetliftComparisonState,
            jetPump: jetPumpState,
            others: otherState,
            collapse: collapseState,
            gasCalculations: GasCalculationState,
            basicCalculations: basicCalculationState,
            surfaceEquipment: surfaceEquipmentState,
            schematic: schematicState,
            wellSurvey: wellSurveyState,
        }, action);
    }
    return jetliftReducer(state, action);
};